import { AxiosResponse } from "axios";
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import axios from "../../../lib/axios";
import { TResponse, TResponseWithQData } from "../../../types/common";
import {
  IFieldWorker,
  IFieldWorkerCreatePayload,
  IFieldWorkerUpdatePayload,
  ICertificationMaster,
  IComplianceMaster,
} from "../../../types/api/fieldWorker";

export const listFieldWorkers = (params: any): Promise<AxiosResponse<TResponseWithQData<IFieldWorker[]>>> =>
  axios.get(API_ENDPOINTS.FIELD_WORKER_LIST, { params });

export const getFieldWorker = (id: number): Promise<AxiosResponse<TResponse<IFieldWorker>>> =>
  axios.get(`${API_ENDPOINTS.FIELD_WORKER_DETAIL}/${id}`);

export const createFieldWorker = (data: IFieldWorkerCreatePayload): Promise<AxiosResponse<TResponse<IFieldWorker>>> =>
  axios.post(API_ENDPOINTS.FIELD_WORKER_CREATE, data);

export const updateFieldWorker = (data: IFieldWorkerUpdatePayload): Promise<AxiosResponse<TResponse<IFieldWorker>>> =>
  axios.put(`${API_ENDPOINTS.FIELD_WORKER_UPDATE}/${data.id}`, data);

export const deleteFieldWorker = (id: number): Promise<AxiosResponse<TResponse<null>>> =>
  axios.delete(`${API_ENDPOINTS.FIELD_WORKER_DELETE}/${id}`);

export const listMasterCertifications = (params?: any): Promise<AxiosResponse<TResponse<ICertificationMaster[]>>> =>
  axios.get(API_ENDPOINTS.MASTER_CERTIFICATIONS, { params });

export const listMasterCompliances = (params?: any): Promise<AxiosResponse<TResponse<IComplianceMaster[]>>> =>
  axios.get(API_ENDPOINTS.MASTER_COMPLIANCES, { params });

export const listWorkerLocations = (): Promise<AxiosResponse<TResponse<any[]>>> =>
  axios.get(API_ENDPOINTS.FIELD_WORKER_LOCATIONS);
